exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pdf-content .toolbar{margin:0 auto;display:flex}.pdf-next .svg-icon,.pdf-prev .svg-icon{width:25px}.player.full-screen{background:#fff}.player.full-screen .pdf-content{margin:0 auto;height:100%!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0eb164c6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Content/src/components/PdfViewer.vue
// module id = 983
// module chunks = 1